// ============================================
// LIGA AJUPAM - "¿Quién sos?" del staff de playoffs (v6.11.208)
// ============================================
// En la 4ta edición se usaron 1–2 cuentas de juez de cancha y de recepción por sede,
// compartidas entre varias personas. Con una cuenta compartida, el log de
// resultados sólo decía "aarauca": no había forma de saber quién cargó qué.
// Cada dispositivo guarda el nombre de quien lo usa y se lo manda a su sesión
// (`staff_set_device_label`); el servidor lo deja en cada resultado cargado.
//
// `normalizeStaffDeviceLabel` replica la limpieza del RPC (espacios y
// controles colapsados, trim, 40 caracteres): lo prueba
// `npm run test:staff-session`.

const STORAGE_KEY = 'staff_device_label';
export const STAFF_DEVICE_LABEL_MAX = 40;

export function normalizeStaffDeviceLabel(raw: string | null | undefined): string | null {
  if (!raw) return null;
  // eslint-disable-next-line no-control-regex
  const cleaned = raw.replace(/[\u0000-\u001f\u007f\s]+/g, ' ').trim().slice(0, STAFF_DEVICE_LABEL_MAX);
  return cleaned.length > 0 ? cleaned : null;
}

export function readStaffDeviceLabel(): string {
  try { return localStorage.getItem(STORAGE_KEY) ?? ''; } catch { return ''; }
}

export function writeStaffDeviceLabel(label: string | null): void {
  try {
    if (label) localStorage.setItem(STORAGE_KEY, label);
    else localStorage.removeItem(STORAGE_KEY);
  } catch { /* modo privado / storage lleno */ }
}
